import { COLORS } from "components/consts";

export const sxTooltip = {
  backgroundColor: "#fff",
  borderRadius: 3,
  boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
  width: "fit-content",
  maxWidth: 450,
  overflow: "hidden",
  p: 2.5,
};

export const sxHeader = {
  display: "flex",
  alignItems: "start",
  justifyContent: "space-between",
};

export const sxCloseButton = { p: 0 };

export const sxBody = {
  mt: 0.5,
  mb: 3,
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
};

export const sxTitle = { fontWeight: 700 };

export const sxContent = { fontSize: 14 };

export const sxFooter = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const sxSkipButton = {
  fontSize: 13,
  fontWeight: 600,
  padding: "17px 16px",
  borderRadius: 2,
  color: COLORS.base,
};

export const sxActions = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 1,
};

export const sxBackButton = {
  border: 1,
  borderColor: COLORS.lightGray,
  fontSize: 13,
  fontWeight: 600,
  padding: "17px 16px",
  borderRadius: 2,
  color: COLORS.base,
};

export const sxNextButton = {
  border: 2,
  borderColor: COLORS.lightBlue,
  fontSize: 13,
  fontWeight: 600,
  padding: 2,
  borderRadius: 2,
};
